import { render, staticRenderFns } from "./selectProducts.vue?vue&type=template&id=8dfa1dc0&scoped=true&"
import script from "./selectProducts.vue?vue&type=script&lang=js&"
export * from "./selectProducts.vue?vue&type=script&lang=js&"
import style0 from "./selectProducts.vue?vue&type=style&index=0&id=8dfa1dc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfa1dc0",
  null
  
)

export default component.exports